module.exports = __webpack_public_path__ + "static/media/salvadilloespecial(1).34d0208e.png";